import { render } from "./ViewModalities.vue?vue&type=template&id=7b61d493"
import script from "./ViewModalities.vue?vue&type=script&lang=js"
export * from "./ViewModalities.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__